var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['alert', {'alert-show': _vm.show && _vm.message }]},[_c('div',{staticClass:"alert-content"},[_c('span',[_c('IconError',{attrs:{"viewBox":"0 0 12 12"}})],1),_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }